import { EmptyState } from '../../empty_state/EmptyState';
import * as React from 'react';
import { Row } from 'antd';

export function InvoicesPendingApprovalTableEmptyState(currentUser) {
	return (
		<EmptyState
			graphic={
				<img
					style={{ marginBottom: 8 }}
					src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
				/>
			}
			headline={'No invoices pending approval in this project!'}
			body={
				<div style={{ textAlign: 'center' }}>
					<div style={{ maxWidth: 440, marginBottom: 16 }}>
						Looks like your team doesn't have any invoices pending approval in this project.
					</div>
				</div>
			}
			height={225}
		/>
	);
}

export function InvoicesGenericEmptyState(currentUser) {
	return (
		<EmptyState
			graphic={
				<img
					style={{ marginBottom: 8 }}
					src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
				/>
			}
			headline={'No invoices in this view!'}
			body={
				<div style={{ textAlign: 'center' }}>
					<div style={{ maxWidth: 440, marginBottom: 16 }}>
						Looks like your team doesn't have any invoices in this View.
					</div>
				</div>
			}
			height={225}
		/>
	);
}

export function DashboardInvoicesEmptyState() {
	return (
		<Row
			justify="center"
			style={{
				fontSize: '16px',
				color: 'rgba(0, 0, 0, .5)',
			}}
		>
			No invoices in this view!
		</Row>
	);
}
